'use strict';
require('./CompanyTaskService.js');
require('../checklist/CompanyChecklistService.js');

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  return false;
}

CompanyTaskDetailCtrl.$inject = [
  '$scope',
  '$controller',
  '$translate',
  '$state',
  '$filter',
  '$stateParams',
  'checklists',
  'taskTypes',
  'CompanyChecklistService',
  'CompanyUserService',
  'CompanyTaskService',
  'task',
  'growl'];
function CompanyTaskDetailCtrl(
  $scope,
  $controller,
  $translate,
  $state,
  $filter,
  $stateParams,
  checklists,
  taskTypes,
  checklistService,
  CompanyUserService,
  CompanyTaskService,
  task,
  growl) {
  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));
  $scope.isEdited = false;
  $scope.task = task;
  $scope.checklists = checklists;
  $scope.taskTypes = taskTypes;

  $scope.task.startAt   = new Date($scope.task.startAt);
  $scope.task.dueAt     = new Date($scope.task.dueAt);
  if ($scope.task.repeatEnd) {
    $scope.task.repeatEnd = new Date($scope.task.repeatEnd);
  }

  if ($scope.task.wholeDay) {
    $scope.dateFormat = $scope.dateWithoutTime;
  } else {
    $scope.dateFormat = $scope.dateWithTime;
  }

  function checkDueAt() {
    if($scope.task.dueAt <= $scope.task.startAt) {
      $scope.task.dueAt = new Date($scope.task.startAt.getTime());
      $scope.task.dueAt.setHours($scope.task.dueAt.getHours() + 1);
    }
  }

  $scope.$watch('[task.startAt, task.dueAt]', function(newValue, oldValue) {
    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
      checkDueAt();
    }
  }, true);
  

  $scope.saveTask = function() {
    $scope.formShow = false;
    var r  = angular.copy($scope.task);
    if (r.repeatEnd) {
      r.repeatEnd = new Date(r.repeatEnd.setDate(r.repeatEnd.getDate()+1));
    }
    r.$update({companyId: $stateParams.companyId, taskId: r.id},
      function(){
        growl.addSuccessMessage($translate.instant('task.update-success'));
        $scope.isEdited = true;
      },
      function(){
        growl.addErrorMessage($translate.instant('task.update-failure'));
      });
  };

  $scope.setCompleted = function() {
    if ($scope.task.completedAt) {
      return;
    }

    var completedAt = new Date();
    $scope.task.completedAt = completedAt;
    $scope.task.completedBy = $scope.currentUser;
    $scope.saveTask();
    $scope.hide(true);
  };

  function calcSpentTime() {
    var current = new Date(), spentTime;
    if ($scope.task.completedAt) {
      spentTime = current - new Date($scope.task.completedAt);
    } else {
      spentTime = current - new Date($scope.task.startAt);
    }

    return $filter('number')(spentTime/3600000, 1);
  }

  $scope.spentTime = calcSpentTime();

  $scope.hide = function(isEdited) {
    if ($state.current.name !== 'root.company.tasks.detail') {
      $scope.$hide();
    } else {
      if ($scope.isEdited === true || angular.isDefined(isEdited)) {
        $state.go('.^', {}, {reload: true});
      } else {
        $state.go('.^');
      }
    }
  };
}

module.exports = CompanyTaskDetailCtrl;

angular.module('dokiv')
  .controller('CompanyTaskDetailCtrl', CompanyTaskDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/tasks/CompanyTaskDetailCtrl.js
// module id = 419
// module chunks = 0